import React from "react";
import { useTranslation } from "react-i18next";
import CommonLayout from "../CommonLayout";
import "./index.css";

const TermsAndConditions: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CommonLayout
      title={t("lblTermsAndConditions")}
      showBackButton={true}
    >
      <iframe
        className="height100 width100 iframeClass noBorder"
        src="https://www.ink-aa.com/terms-conditions.html"
        title={t("lblTermsAndConditions")}
        frameBorder="0"
        style={{ paddingTop: "20px", paddingBottom: "20px" }}
      />
    </CommonLayout>
  );
};

export default TermsAndConditions;